export const insideSalesCategoryNames = {
  attachments: 'Attachments',
  Proposals: 'Proposals',
};
